import React, { useEffect } from "react";
// import { Buffer } from "buffer";
import "../IndexPage/IndexPage.css";

function DessertsEditPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  //   const [loading, setLoading] = useState(true);
  // const [desserts, setSugested] = useState([]);


  // useEffect(() => {
  //   fetch("https://suntaka-backend-production.up.railway.app/api/dessertspdf")
  //     .then(async (response) => {
  //       if (response.ok) {
  //         // Si la respuesta es válida, intentar procesarla como JSON
  //         const { data: buffer } = await response.json();
  //         setSugested(buffer.data);
  //       } else {
  //         // Si la respuesta no es válida, intentar procesarla como un archivo binario
  //         const buffer = await response.arrayBuffer();
  //         setSugested(buffer);
  //       }
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       setLoading(false);
  //     });
  // }, []);



  return (
    <div>
    <div className="desserts-background"></div>
    <div className="card-container">
      <img
      className="pdf-desserts"
      src="img/postre_y_destilados.png"
      alt="Postres y Destilados">

      </img>
</div>
      {/* {loading ? (
        <div className="loader">
          <span>Cargando...</span>
        </div>
      ) : (
        <div className="pdfReader" key={desserts.id}>
          <iframe
            title="Postres"
            src={`data:application/pdf;base64,${Buffer.from(
              desserts,
              "binary"
            )}`}
            width="100%"
            height="200%"
            type="application/pdf"
            alt={`Imagen de postres`}
          />
        </div>
      )} */}

    </div>
  );
}

export default DessertsEditPage;

